<template>
  <div
    class="summary-card summary-card-up-to-date"
    :class="{ compact, selected }"
    @click="emit('click')"
  >
    <div class="summary-card-header">
      <div class="summary-card-title-row">
        <DpplSvg
          class="summary-card-icon"
          file-name="summary-check-circle"
        />
        <span class="text-h3 text-dark summary-card-label">Up-to-date acknowledgements</span>
      </div>
    </div>
    <p class="summary-card-value text-darkest">
      {{ percentage }}%
    </p>
    <div class="summary-card-progress-track">
      <div
        class="summary-card-progress-fill"
        :style="{ width: `${percentage}%` }"
      />
    </div>
  </div>
</template>

<script setup>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

defineProps({
  percentage: { type: Number, default: 0 },
  compact: { type: Boolean, default: false },
  selected: { type: Boolean, default: false },
});

const emit = defineEmits(['click']);
</script>

<style lang="less" scoped>
.summary-card {
  position: relative;
  min-width: 0;
  height: 136px;
  padding: 16px;
  border-radius: 6px;
  border: 1px solid;
  background: @white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  cursor: pointer;
}

.summary-card-up-to-date {
  border-color: @teal-500;

  &.selected {
    background: @teal-100;
  }

  &:hover {
    box-shadow:
      0 30px 33px 0 fade(@black, 5%),
      0 22px 17px 0 fade(@black, 4%),
      0 12px 10px 0 fade(@black, 4%),
      0 2px 2px 0 fade(@black, 2%),
      0 6px 5px 0 fade(@black, 3%);
  }

  &.compact {
    .summary-card-label {
      display: none;
    }
  }
}

.summary-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
  width: 100%;
  min-height: 28px;
}

.summary-card-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.summary-card-icon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  color: @teal-500;
}

.summary-card-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.summary-card-value {
  font-size: 36px;
  font-weight: 700;
  line-height: 1.25;
  margin: 0 0 4px;
}

.summary-card-progress-track {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background: @stroke-default;
  margin-bottom: 8px;
  overflow: hidden;
  box-shadow: inset 0 4px 4px 0 fade(@teal-500, 12%);
}

.summary-card-progress-fill {
  height: 100%;
  border-radius: 4px;
  background: @teal-500;
  transition: width 0.2s ease;
}
</style>
